import "../../i18n";

import type { ReactNode } from "react";
import { Suspense } from "react";
import { LoadingBlock } from "../../components/LoadingBlock";
import { useStoredApiToken } from "../../store/apiToken";
import { Login } from "../Login";
import classes from "./Layout.module.css";
import { Sidebar } from "./Sidebar";

interface LayoutProps {
  children?: ReactNode;
}

export const Layout = (props: LayoutProps) => {
  const { children } = props;
  const [apiToken] = useStoredApiToken();
  const isValidSession = typeof apiToken !== "undefined";

  return (
    <div className={classes.root}>
      <Sidebar className={classes.sidebar} />

      <main className={classes.main}>
        <Suspense fallback={<LoadingBlock />}>
          {isValidSession ? children : <Login />}
        </Suspense>
      </main>
    </div>
  );
};
